import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Text, tokens } from '@fhs/ui';
import { CHECKOUT_SERVICE_MODE_DETAILS } from '@fhs-legacy/frontend/src/utils/test-ids';

interface ServiceModeDetailsWrapperProps {
  isDeliveryOrder: boolean;
  children: React.ReactNode;
}

export function ServiceModeDetailsWrapper({
  isDeliveryOrder,
  children,
}: ServiceModeDetailsWrapperProps) {
  const title = isDeliveryOrder ? 'Delivery Details' : 'Pick Up Details';

  return (
    <View testID={CHECKOUT_SERVICE_MODE_DETAILS} style={styles.wrapper}>
      <Text.Heading type="four" style={styles.title}>
        {title}
      </Text.Heading>
      <View style={styles.container}>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    marginTop: 32,
    marginHorizontal: 28,
  },
  title: {
    lineHeight: 19.6,
    marginBottom: 12,
  },
  container: {
    alignSelf: 'stretch',
    borderRadius: 8,
    borderColor: tokens.colors.$black10,
    borderWidth: 1,
  },
});
